import React from 'react';
import { useNavigate } from 'react-router-dom';
import AIAssistant from '../components/AIAssistant.jsx';

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="min-h-[100dvh] flex items-center justify-center bg-gradient-to-r from-gray-50 to-gray-100 p-4">
        <div className="w-full max-w-md bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Icon Header */}
          <div className="bg-red-50 py-8 flex justify-center">
            <div className="bg-white p-3 rounded-full shadow-md -mb-10 border-2 border-red-100">
              <svg
                className="h-12 w-12 text-red-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                />
              </svg>
            </div>
          </div>

          {/* Content */}
          <div className="px-8 pt-12 pb-8">
            <h1 className="text-2xl font-QBold text-center text-gray-800 mb-2">
              Access Restricted
            </h1>
            <p className="text-gray-600 font-QMedium text-center mb-6">
              You don't have the necessary permissions to view this page.
            </p>

            <div className="flex flex-col font-QSemiBold space-y-3 mt-6">
              <button
                onClick={() => navigate(-1)}
                className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition duration-200"
              >
                Go Back
              </button>
              <button
                onClick={() => navigate('/')}
                className="w-full py-3 px-4 border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium rounded-lg transition duration-200"
              >
                Return Home
              </button>
            </div>
          </div>
        </div>
      </div>
      <AIAssistant />
    </>
  );
};

export default NotAuthorized;